import { Button } from '@components/Button/';
import EVImg from '@components/EVImg';
import { AspectBox } from '@components/Layout';
import Block from '@components/Layout/Block';
import RichText from '@components/RichText';
import { FC, ReactNode, useEffect, useState } from 'react';
import {
  ButtonContainer,
  ContentContainer,
  Eyebrow,
  GridContainer,
  Header,
  ImageContainer,
  Text,
} from './styles';
const { richTextFromMarkdown } = require('@contentful/rich-text-from-markdown');

export interface TextAndImageBlockProps {
  eyebrow?: string;
  header?: string;
  img?: string;
  imgFocalPoint?: any; // Adjust type as necessary
  alt_text?: string;
  bodyText?: string | ReactNode;
  cta?: { text: string; url: string }[];
  reverse?: boolean;
}

const TextAndImageBlock: FC<TextAndImageBlockProps> = ({
  header,
  eyebrow,
  img,
  imgFocalPoint,
  alt_text,
  bodyText,
  cta,
  reverse,
}) => {
  // Convert markdown to rich text
  const [richTextBody, setRichTextBody] = useState<ReactNode | null>(null);
  const convertToRichTextFromMarkdown = async () => {
    const richText = await richTextFromMarkdown(bodyText);
    if (richText) {
      setRichTextBody(<RichText richText={richText} />);
    } else {
      setRichTextBody(<Text>{bodyText}</Text>);
    }
  };
  useEffect(() => {
    convertToRichTextFromMarkdown();
  }, [bodyText]);

  return (
    <Block>
      <GridContainer $reverse={reverse}>
        {imgFocalPoint ? (
          <div>
            <ImageContainer>
              <AspectBox $ratio={1}>
                {imgFocalPoint && (
                  <EVImg
                    imageFocalPointData={imgFocalPoint}
                    alt={alt_text || ''}
                    sizes={['300px', '300px', '500px', '500px']}
                  />
                )}
              </AspectBox>
            </ImageContainer>
          </div>
        ) : (
          <div>
            <ImageContainer>
              <AspectBox $ratio={1}>
                {img && <EVImg src={img} alt={alt_text || ''} sizes={['100vw']} />}
              </AspectBox>
            </ImageContainer>
          </div>
        )}
        <ContentContainer>
          <div>
            {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
            {header && <Header>{header}</Header>}
            {richTextBody && richTextBody}
            <ButtonContainer>
              {cta &&
                cta.map((obj, ind) => (
                  <div key={ind}>
                    <Button
                      arrow={false}
                      variant={'secondaryWhite'}
                      url={obj.url}
                      label={obj.text}
                    />
                  </div>
                ))}
            </ButtonContainer>
          </div>
        </ContentContainer>
      </GridContainer>
    </Block>
  );
};

export default TextAndImageBlock;
